<template>
  <div v-html="item.content || 'Add content here.'"></div>
</template>

<script setup>
import { defineProps } from 'vue';
const props = defineProps({
  item: Object
});
</script>